import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import ClientsNavbar from "./ClientsNavbar";
import DmNavbar from "./DmNavbar";
import DmexeNavbar from "./DmexeNavbar";
import SalesNavbar from "./SalesNavbar";
import SalesexeNavbar from "./SalesexeNavbar";
import FinanceNavbar from "./FinanceNavbar";
import AdminNavbar from "./AdminNavbar";
import CommonNavBar from "./CommonNavBar";
import CommonNavBarRect from "./CommonNavBarRect";

const Sidebar = (props) => {
  const { toggleSidebar, isSidebarOpen, isOpen, decodedToken } = props;
  // const [isCollapsed, setIsCollapsed] = useState(false);

  // const handleToggleSidebar = () => {
  //   setIsCollapsed(!isCollapsed);
  // };
  // console.log('hello');

  console.log("decodedToken ==>", decodedToken);

  return (
    <>
      <aside
        className={`app-menu navbar-menu ${
          isSidebarOpen ? "sidebar-expanded" : "sidebar-collapsed"
        }`}
      >
        {/* Brand Logo */}
        <div className="navbar-brand-box">
          <Link to="/" className="logo">
            {isSidebarOpen ? (
              <img src="../assets/images/logo-light.png" height="40" alt="" />
            ) : (
              <img src="../assets/images/fav.png" height="35" alt="" />
            )}
          </Link>
          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src="../assets/images/fav.png" alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src="../assets/images/logo-light.png" alt="" height="40" />
            </span>
          </Link>
        </div>

        {/* Menu Items */}
          <div className="container-fluid">
            <div id="two-column-menu"></div>
         <div
        className="overflow-auto"
        style={{
            flex: 1,
            height: "calc(100vh - 70px)"
        }}
    >
            <ul className="navbar-nav" id="navbar-nav">
              <li className="menu-title">
                <i className="ri-more-fill me-3"></i>
                <span data-key="t-pages">Menu</span>
              </li>

              <li className="nav-item">
                <Link className="nav-link menu-link" to="/dashboard">
                  <i className="ri-dashboard-2-line"></i>
                  <span data-key="t-dashboard">
                    {isSidebarOpen && <span>Dashboard</span>}
                  </span>
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link menu-link" to="/task-tracker">
                  <i className="ri-task-line"></i>
                  <span data-key="t-task-tracker">
                    {isSidebarOpen && <span>Task Tracker</span>}
                  </span>
                </Link>
              </li>

              {decodedToken?.UsrRoleId === 2 && <SalesNavbar />}
              {decodedToken?.UsrRoleId === 13 && <SalesNavbar />}
              {decodedToken?.UsrRoleId === 4 && <SalesexeNavbar />}
              {decodedToken?.UsrRoleId === 6 && <ClientsNavbar />}
              {decodedToken?.UsrRoleId === 3 && <DmNavbar />}
              {decodedToken?.UsrRoleId === 5 && <DmexeNavbar />}
              {decodedToken?.UsrRoleId === 8 && <FinanceNavbar />}
              {(decodedToken?.UsrRoleId === 11 ||
                decodedToken?.UsrRoleId === 12) && (
                <CommonNavBar decodedToken={decodedToken} isSidebarOpen={isSidebarOpen} />
              )}
              {(decodedToken?.UsrRoleId === 1 ||
                decodedToken?.UsrRoleId === 10) && <AdminNavbar />}
              {(decodedToken?.UsrRoleId === 14 ||
                decodedToken?.UsrRoleId === 15) && <AdminNavbar />}
              {decodedToken?.UsrRoleId === 16 ||
              decodedToken?.UsrRoleId === 17 ? (
                <CommonNavBarRect decodedToken={decodedToken} />
              ) : null}

              {decodedToken?.UsrRoleId !== 6 && (
                <>
                  <li className="nav-item">
                    <Link
                      className="nav-link menu-link"
                      to="/influencer-discover"
                    >
                      <i className="ri-dashboard-2-line"></i>
                      <span data-key="t-dashboard">Influencer Discover</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link menu-link"
                      to="/influencer-insights"
                    >
                      <i className="ri-dashboard-2-line"></i>
                      <span data-key="t-dashboard">Influencer Insights</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link menu-link" to="/exports-list">
                      <i className="ri-dashboard-2-line"></i>
                      <span data-key="t-dashboard">Exports</span>
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>

        <div className="sidebar-background"></div>
      </aside>
    </>
  );
};

export default Sidebar;
